webpackJsonp([95318795803895],{

/***/ 1770:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"EmailTemplate","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"htmlTemplate","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"updatedAt","type":{"kind":"SCALAR","name":"NaiveDateTime","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-email-template-ac4a9f1ee011b5ca8272.js